var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"drop":function($event){$event.preventDefault();return _vm.dropFile.apply(null, arguments)},"dragover":function($event){$event.preventDefault();return _vm.dragOver(true)},"dragleave":function($event){$event.preventDefault();return _vm.dragOver(false)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }